module.exports = __webpack_public_path__ + "img/task_double_arrow.f3cd598e.svg";